import React from "react";
import DashboardContainer from "../layout/DashboardContainer";
import { StripeConnection } from "./StripeConnection";

export function ContractorSettings() {
  return (
    <DashboardContainer
      title="Payment Settings"
    >
      <div className="space-y-6">
        <StripeConnection />
        
        {/* Future settings sections can be added here */}
        {/* Example:
        <Card>
          <CardHeader>
            <CardTitle>Invoice Settings</CardTitle>
            <CardDescription>Configure your default invoice settings</CardDescription>
          </CardHeader>
          <CardContent>
            // Invoice preferences
          </CardContent>
        </Card>
        */}
      </div>
    </DashboardContainer>
  );
} 